import React from "react";
import CrrInput from "../UI/CrrInput/CrrInput";
import CrrButton from "../UI/CrrButton/CrrButton";
import { Button, Dropdown } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";

const ListHeader = ({
  searchPlaceholder,
  addButtonTitle,
  addButtonPlaceholder,
  handleSearch,
  handleAddClick,
  isDownloading,
  downloadMenu,
  styles,
}) => {
  return (
    <div className="header-options" style={styles}>
      {handleSearch ? (
        <CrrInput
          className="search search-input"
          onKeyUp={handleSearch}
          placeholder={searchPlaceholder}
        />
      ) : downloadMenu ? (
        <Dropdown
          overlay={downloadMenu}
          placement="bottomRight"
          trigger={["click"]}
        >
          <Button
            type="primary"
            className="btn create-survey-btn download-btn"
            disabled={isDownloading}
            loading={isDownloading}
          >
            {isDownloading ? "DOWNLOADING" : <>DOWNLOAD</>}
            <CaretDownOutlined />
          </Button>
        </Dropdown>
      ) : (
        ""
      )}

      <CrrButton
        className="btn create-survey-btn"
        onClick={handleAddClick}
        title={addButtonTitle}
      >
        {addButtonPlaceholder}
      </CrrButton>
    </div>
  );
};

export default ListHeader;
